import FootballStatsCollection from "./football-stats-collection";
import FootballPlayerStatsCollection from "./football-player-stats-collection";
import FootballPeriodStatsCollection from "./football-period-stats-collection";

export default class FootballTeamStatsCollection extends FootballStatsCollection {
    constructor(team, statLogs = []) {
        super(
            statLogs.filter((s) => {
                return s.teamId === team.id;
            })
        );
        this.team = team;
    }

    _getTotalPeriods() {
        const periodsWithStats = this.statLogs.map((sl) => sl.period);

        return periodsWithStats.length
            ? [...Array(Math.max(...periodsWithStats)).keys()]
            : [];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            id: this.team.id,
            teamName: this.team.teamName,
            players: this.team.players.map((player) =>
                new FootballPlayerStatsCollection(
                    player,
                    this.statLogs
                ).toJSON()
            ),
            periods: this._getTotalPeriods().map((period) =>
                new FootballPeriodStatsCollection(
                    period + 1,
                    this.statLogs
                ).toJSON()
            )
        };
    }
}
